import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import axios from '../axios'
import requests from '../request'
const baseUrl = "https://image.tmdb.org/t/p/original/";



const ImgSlider = () => {

  const [movie,setMovie] = useState([])

useEffect(()=>{
  const fetchData = async ()=>{
    const request = await axios.get(requests.comedyMovies)
    // const randomNum = Math.floor(Math.random() * request.data.results.length -2)



    // let r = request.data.results[randomNum]
    // setMovie(r)
    setMovie(request.data.results)

  }
  fetchData()
},[])
  let setting = {
    dots: true,
    infinite: true,
    speed: 500,
    SlidersToShow: 1,
    autoplay: true,
  };
  return (
    <Carousel {...setting}>
      {
        movie.map(movie=>{
          return <>
      <Wrap>
      <img src={`${baseUrl}${movie.backdrop_path}`}/>
      </Wrap>
          </>
        })

      }


      {/* <Wrap>
        <img src="images/slider-badging.jpg" alt="slider" />
      </Wrap>
      <Wrap>
        <img src="images/slider-badging.jpg" alt="slider" />
      </Wrap>
      <Wrap>
        <img src="images/slider-badag.jpg" alt="slider" />
      </Wrap> */}

    </Carousel>
  );
};

export default ImgSlider;
const Carousel = styled(Slider)`
            margin-top: 20px;
            color: white;

            ul li button{
                &before{
                    font-style: 20px;
                    color: white;
                }
            }

            li.slick-active button:before{
                color: white;
            }
            .slick-list{
                overflow: visible;
            }
            button{
                z-index: 1;
            }
`;

const Wrap = styled.div`
                cursor: pointer;
            img{
                border: 4px solid transparent;
                border-radius: 10px;
                width: 100%;
                /* height: 100%; */
                height: 40rem;
                object-fit:cover ;
                box-shadow: rgb(0 0 0 /69%) 0px 26px 38px -10px, rgb(0 0 0 /73%) 0px 16px 10px -18px;
                transition-duration: 280ms;
                &:hover{
                    border-radius: 10px;
                    border: 4px solid rgb(249, 249, 249, 0.8);
                }
            }
`;
